module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/905aaa5ec7fca7cf364f5e74bcb10be1.png";